export const APP_URLS = {
  memberBenefits: "/account/member-benefits",
  orderHistory: "/account/order-history",
  myAccount: "/account",
  shoppingCart: "/basket",
  searchAction: "/shop/search",
  myMembership: "/account/my-membership",
  wishlist: "/account/wishlist",
  profile: "/account/profile",
  addressBook: "/account/address-book",
  referAFriend: "/account/refer-a-friend",
  orderItAgain: "/account/favourites/order-it-again",
  forYou: "/account/favourites/for-you"
};
